import ko from 'knockout'
import jQuery from 'jquery'
import * as stateMachine from 'rwwa-rx-state-machine'
import * as bodyScrollLock from '@mobi/utils/functions/bodyScrollLock'
import * as modalIntents from '@classic/AppUtils/Framework/Intent/modal'
import * as messageBus from '@classic/Foundation/Services/MessageBusService'
import * as analytics from '@classic/Foundation/Analytics/Analytics'
import { appHistory } from '@core/Utils/routing/history'

import './modal-register'

export const close = modalIntents.close

export const open = (title: string, component: unknown) => {
  modalIntents.open({ component, title })
}

export function init() {
  window.addEventListener('hashchange', close)
  const element = document.getElementById('modal-container-host')
  if (element) {
    ko.cleanNode(element)
  }
  ko.applyBindings({ viewModel }, element)
}

const defaultState = {
  title: 'No title',
  isOpen: false,
  close,
  component: null,
  showBackButton: false,
  back: () => {
    appHistory.back()
  },
}

function setState(currentState: Record<string, unknown>, state: Record<string, unknown>) {
  return Object.assign({}, currentState, state)
}

function modalDriver(state: Record<string, unknown>, intent: stateMachine.Signal) {
  state = state || defaultState

  switch (intent.tag) {
    case modalIntents.open: {
      analytics.trackModalState(true, intent.data.title)
      if (document.body.classList.contains('js-has-open-modal'))
        publishModalClose(state.title as string)

      const modalEl = document.getElementById('modal-container')
      bodyScrollLock.registerBodyScrollLock(modalEl as HTMLDivElement)

      const capturedTop = getScrollTop()
      setScrollTop(0)

      document.body.classList.add('js-has-open-modal')

      return setState(state, {
        capturedTop: capturedTop,
        isOpen: true,
        title: intent.data.title,
        component: intent.data.component,
      })
    }

    case modalIntents.close: {
      analytics.trackModalState(false, '')
      document.body.classList.remove('js-has-open-modal')

      setScrollTop(state.capturedTop as number)
      publishModalClose(state.title as string)

      const modalEl = document.getElementById('modal-container')
      bodyScrollLock.deregisterBodyScrollLock(modalEl as HTMLDivElement)

      return setState(state, { isOpen: false })
    }
  }
  return state
}

const $modalState = stateMachine.attachDriver({ path: 'modal', driver: modalDriver })

const viewModel = {
  title: ko.observable().extend({ deferred: true }),
  isOpen: ko.observable().extend({ deferred: true }),
  close: close,
  showBackButton: ko.observable().extend({ deferred: true }),
  back: () => {
    appHistory.back()
  },
  component: ko.observable().extend({ deferred: true }),
}

;(viewModel as unknown as { displayComponent: unknown }).displayComponent = ko
  .pureComputed(() => viewModel.isOpen() && viewModel.component())
  .extend({ deferred: true })

$modalState.distinctUntilChanged().subscribe(function (modal) {
  viewModel.title(modal.title)
  viewModel.isOpen(modal.isOpen)
  if (viewModel.component() !== (modal && modal.component)) {
    viewModel.component(modal.component)
  }
})

function publishModalClose(title: string) {
  messageBus.publish('modal.did_close', { title: title })
}

function setScrollTop(scrollTop: number) {
  jQuery('html, body').animate({ scrollTop }, 0)
}

function getScrollTop() {
  // if the element is not scrolled, it will (should) return 0
  return Math.max(jQuery('body').scrollTop(), jQuery('html').scrollTop())
}
